__webpack_require__.p = "https://static.advice.online/packs/";